import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Button,
  Spin, 
  Modal as AntModal, 
  Row, 
  Col, 
  Typography,
  Alert as AntAlert, 
  message as antdMessage, 
  Space, 
  Descriptions,
  Card,
  Input
} from "antd";
import ScaffoldCanvas  from "./ScaffoldCanvas"; 
import MandatoryParameters  from "./MandatoryParameters"; 
import AdvancedParameters  from "./AdvancedParameters"; 
import { postRequest } from "../../util/service";
import { stringToBoolean, isValidScaffoldSmiles } from "../../util/helper"; 
import { ATTRIBUTE, BUTTON_LABEL } from "../../constants/labels";
import { ATTRIBUTE_MODEL } from "../../constants/attributeModel";
import * as AD from "../../constants/attributeDetails";   
import dayjs from "dayjs";
import { normaliseFromBackend } from "../../util/normalise";
const { Text, Title } = Typography; 
const {
  dependantFields,
  dependantFieldDetails,
  sliderFields,
  molecularScaffold,
  learningRelated,
  molecularScaffoldAdvance,
  learningRelatedAdvance,
  contraintsAdvance,
  constraints1,
  constraints2,
  constraints3,
  constraints4,
  w_filters_1,
  w_filters_2,
  w_filters_3,
  w_filters_4,
  w_filters_5,
  w_filters_6,
  w_filters_7,
  w_filters_8,
  w_filters_9,
  w_filters_10,
  w_filters_11,
} = AD;

const ALL_FIELD_DEFS = [
  molecularScaffold,
  molecularScaffoldAdvance,
  learningRelated,
  learningRelatedAdvance,
  contraintsAdvance,
  constraints1,
  constraints2,
  constraints3,
  constraints4,
  w_filters_1,
  w_filters_2,
  w_filters_3,
  w_filters_4,
  w_filters_5,
  w_filters_6,
  w_filters_7,
  w_filters_8,
  w_filters_9,
  w_filters_10,
  w_filters_11,
].flat();

const SLIDER_KEY_MAP = Object.fromEntries(
  sliderFields.map(({ name, fields }) => [
    name,
    [fields[0].l_limit, fields[0].u_limit],
  ])
);


const Attribute = ({ onBackHandlerChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userName = useSelector((state) => state.header?.userName);
  const userEmail = useSelector((state) => state.header?.userEmail);
  const [openSubmitConfirmModal, setOpenSubmitConfirmModal] = useState(false);
  const [expandAdvancePara, setExpandAdvancePara] = useState(false);
  const [expandSubgroup, setExpandSubgroup] = useState(false); 
  const [formData, setFormData] = useState({...ATTRIBUTE_MODEL}); 
  const [errorMessages, setErrorMessages] = useState([]); 
  const [batchDetails, setBatchDetails] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const initialFormDataRef = useRef({ ...ATTRIBUTE_MODEL });
  const cancelHandlerRef = useRef(null);

     const {  batchId } = useParams();          // <-- will be undefined for create


  const { state } = location;
console.log("state --->", state);
    const {
      projectId,
      projectName,
      owners,
      teamMembers,
      description,
      isReTrigger,
      ...batchInfoData
    } = state || {};
  console.log("batchInfoData --->", projectId, projectName, owners, teamMembers, description, batchInfoData); 
  const handleCloseSubmitConfirmModal = () => setOpenSubmitConfirmModal(false);
  const handleErrorAlertClose = () => setErrorMessages([]);
  const isEditOrReTriggerMode = !!batchId;
  const isReTriggerMode = isReTrigger || false;
  const isCloneMode = !!batchId && !isReTriggerMode;

useEffect(() => {
  let nextFormData;
  if (isEditOrReTriggerMode) {
      const cleaned = normaliseFromBackend(batchInfoData.batchInfoData);
      
      // ✅ NEW: Pre-populate description for re-trigger
      if (isReTriggerMode) {
        cleaned.exp_description = `This is extended from ${batchId}`;
      }
      
      nextFormData = { ...ATTRIBUTE_MODEL, ...cleaned };
    } else {
      // ✅ NEW: Pre-populate description for a new experiment.
      nextFormData = { ...ATTRIBUTE_MODEL, exp_description: "New Generation" };
    }

  initialFormDataRef.current = nextFormData;
  setFormData(nextFormData);
  setExpandAdvancePara(false);
  setExpandSubgroup(false);
  setErrorMessages([]);
},[batchId, isEditOrReTriggerMode, batchInfoData.batchInfoData, isReTriggerMode]); 


  const handleInputChange = (eventOrData) => {
    let name, value, type;

    if (eventOrData && eventOrData.target && eventOrData.target.hasOwnProperty("value")) { 
        name = eventOrData.target.name;
        value = eventOrData.target.value;
        type = eventOrData.target.type;
        if (type === "checkbox") { // For AntD Checkbox (if used directly)
            value = eventOrData.target.checked;
        } else if (type === "radio") { // For AntD Radio.Group
             value = eventOrData.target.value; // Already correct
        }
    } else if (typeof eventOrData === "object" && eventOrData !== null && eventOrData.name !== undefined) {
        // Custom structure like {name, value, type}
        name = eventOrData.name;
        value = eventOrData.value;
        type = eventOrData.type || "text";
    } else {
        console.warn("handleInputChange called with unexpected argument:", eventOrData);
        return; 
    }
    
    if (typeof value === "string" && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) { 
      value = stringToBoolean(value);
    } else if (value === "") {
      value = null;
    }
    
    setFormData(prevFormData => {
        let newFormData = { ...prevFormData, [name]: value };
        if (dependantFields.includes(name) && (value === false || value === null)) {
            dependantFieldDetails.forEach((item) => {
                if (item?.name === name) {
                    item?.fields?.forEach((field) => {
                        newFormData[field.key] = field.default;
                    });
                }
            });
        } else if (type === "number" || type === "slider") { 
            newFormData[name] = parseFloat(value);
        }
        return newFormData;
    });
  };
  
  const handleSigmoidValue = (paramLabel, eventArg) => { 
    let value = parseFloat(eventArg.target.value); // Assuming event structure for now
    // If AntD InputNumber calls this directly with value:
    // let value = parseFloat(eventArg); 

    setFormData(prevFormData => {
        let currentParams = [...(prevFormData.docking_reward_sigmoid_params || [1,0,0,-1])]; 
        if (paramLabel === "a") currentParams[0] = value;
        if (paramLabel === "b") currentParams[1] = value;
        if (paramLabel === "c") currentParams[2] = value;
        if (paramLabel === "d") currentParams[3] = value;
        return { ...prevFormData, docking_reward_sigmoid_params: currentParams };
    });
  };

  const handleSlider = (name, sliderValue) => { // AntD Slider passes value or [min, max]
    setFormData(prevFormData => {
        let obj = { ...prevFormData };
        let l_value = Array.isArray(sliderValue) ? sliderValue[0] : undefined; 
        let u_value = Array.isArray(sliderValue) ? sliderValue[1] : undefined;
        sliderFields.forEach((item) => {
          if (item?.name === name) {
            item?.fields?.forEach((field) => {
              if (l_value !== undefined) obj[field.l_limit] = l_value;
              if (u_value !== undefined) obj[field.u_limit] = u_value;
            });
          }
        });
        return obj;
    });
  };


const isFormValid = () => {
  // Experiment name must be provided (non-empty after trimming)
  if (!formData.exp_name || String(formData.exp_name).trim() === "") {
    return false;
  }

  for (const f of ALL_FIELD_DEFS) {
    if (!f.required)                           continue;
    if (f.hidden === true)                    continue;
    if (f.visible === false)                  continue;
    if (f.disabled === true)                  continue; // disabled fields are ignored
    if (!displayField(f.label))               continue; // dependency toggles

    if (f.type === "slider") {
      const pair = SLIDER_KEY_MAP[f.label];
      if (!pair) continue; // should never happen
      const [loKey, hiKey] = pair;
      const lo = formData[loKey];
      const hi = formData[hiKey];
      if (lo === null || hi === null)            return false;
      if (lo === undefined || hi === undefined)  return false;
      if (isNaN(lo) || isNaN(hi))                return false;
      continue;
    }

    const v = formData[f.label];

    if (f.type === "toggle") {
      if (v === undefined || v === null)         return false;
    } else if (f.type === "number") {
      if (v === undefined || v === null)         return false;
      if (v === "" || isNaN(v))                  return false;
    } else { // text, select, file …
      if (v === undefined || v === null || v === "") return false;
    }
  }
    const scaffoldOK = isValidScaffoldSmiles(formData.scaffold);
    const cappingOK = !formData.capping || isValidScaffoldSmiles(formData.capping_scaffold);
    const iterationsOK = Number(formData.num_iterations) <= 30000;
  
    return scaffoldOK && cappingOK && iterationsOK;
  };

  const cleanObject = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));

  const preparePayload = () => { 
    const currentFormData = { ...formData }; 
    const w_filters = {
      "w_nchiral": currentFormData.limit_chiral_centers ? [currentFormData.w_nchiral_0, currentFormData.w_nchiral_1] : null,
      "w_lrsz": currentFormData.limit_ring_size ? [currentFormData.w_lrsz_0, currentFormData.w_lrsz_1] : null,
      "w_arring": currentFormData.limit_number_of_aromatic_rings ? [currentFormData.w_arrings_0, currentFormData.w_arrings_1] : null,
      "w_nrings": currentFormData.limit_number_of_rings ? [currentFormData.w_nrings_0, currentFormData.w_nrings_1] : null,
      "w_amw": [currentFormData.w_amw_0, currentFormData.w_amw_1], 
      "w_rotbond": currentFormData.limit_rotatable_bonds ? [currentFormData.w_rotbond_0, currentFormData.w_rotbond_1] : null,
      "w_halogen": currentFormData.limit_halogens ? [currentFormData.w_halogen_0, currentFormData.w_halogen_1] : null,
      "w_ro5_ohnh": currentFormData.Limit_OH_NH ? [currentFormData.w_ro5_ohnh_0, currentFormData.w_ro5_ohnh_1] : null,
      "w_nvrtspsa": currentFormData.limit_polar_surface_area ? [currentFormData.w_nvrtspsa_0, currentFormData.w_nvrtspsa_1] : null,
      "w_hdons": currentFormData.limit_H_bond_donors ? [currentFormData.w_hdons_0, currentFormData.w_hdons_1] : null,
      "w_hacts": currentFormData.limit_H_bond_acceptors ? [currentFormData.w_hacts_0, currentFormData.w_hacts_1] : null
    };
    const cleanedWFilters = cleanObject(w_filters);
    const hasValidCappingScaffold = isValidScaffoldSmiles(currentFormData.capping_scaffold);
    let payloadModelObj = { ...currentFormData, w_filters: cleanedWFilters };
    if (!payloadModelObj.include_tsubmatching) payloadModelObj.SMARTS_file = null;
    payloadModelObj.potency_model_script = payloadModelObj.potency_model_script === "None" ? null : payloadModelObj.potency_model_script;
    payloadModelObj.docking_model = payloadModelObj.docking_model === "None" ? null : payloadModelObj.docking_model;
    payloadModelObj.blocks_file_type = payloadModelObj.blocks_file_type || "Blocksfiles";
    payloadModelObj.include_medchemrules = false;
    payloadModelObj.medchemrules_thres = null;
    payloadModelObj.capping = hasValidCappingScaffold;
    payloadModelObj.capping_scaffold = hasValidCappingScaffold ? payloadModelObj.capping_scaffold : null;
    payloadModelObj.exp_name = formData.exp_name;
    payloadModelObj.exp_description = formData.exp_description ? formData.exp_description : null;
    payloadModelObj.restart_generation = isReTriggerMode;
    payloadModelObj.parent_batch_id = isReTriggerMode ? batchId : null;
    const keysToRemove = [
      "w_amw_0", "w_amw_1", "w_arrings_0", "w_arrings_1", "w_hacts_0", "w_hacts_1",
      "w_halogen_0", "w_halogen_1", "w_hdons_0", "w_hdons_1", "w_lrsz_0", "w_lrsz_1",
      "w_nchiral_0", "w_nchiral_1", "w_nrings_0", "w_nrings_1", "w_nvrtspsa_0", "w_nvrtspsa_1",
      "w_ro5_ohnh_0", "w_ro5_ohnh_1", "w_rotbond_0", "w_rotbond_1", "weight_decay"
    ];
    keysToRemove.forEach(key => delete payloadModelObj[key]);
    console.log("Prepared payload model object:", payloadModelObj);
    return payloadModelObj;
  };

  const validateFormForSubmission = () => { 
      const messages = [];
      if (!formData.exp_name || String(formData.exp_name).trim() === "") {
        messages.push("Experiment Name is required.");
      }
      if (!isValidScaffoldSmiles(formData.scaffold)) {
        messages.push("Scaffold SMILES must include a growth point (*) and be at least 3 characters long.");
      }
      if (formData.capping && !isValidScaffoldSmiles(formData.capping_scaffold)) {
        messages.push("Capping Scaffold SMILES must include a growth point (*) and be at least 3 characters long.");
      }
    if ((formData.min_blocks > formData.max_blocks) || (formData.min_blocks === formData.max_blocks))
      messages.push("Maximum fragments should be greater than Minimum fragments.");
    if (Number(formData.num_iterations) > 30000)
      messages.push("Number of iterations cannot be greater than 30000.");
    if (formData.include_clogD && ((parseFloat(formData.clogD_l_limit) > parseFloat(formData.clogD_u_limit)) || (parseFloat(formData.clogD_l_limit) === parseFloat(formData.clogD_u_limit))))
      messages.push("clogD Upper Limit should be greater than or equal to clogD Lower Limit.");
    if (formData.include_pKa && ((parseFloat(formData.pKa_llimit) > parseFloat(formData.pKa_ulimit)) || (parseFloat(formData.pKa_llimit) === parseFloat(formData.pKa_ulimit))))
      messages.push("pKa Upper Limit should be greater than or equal to pKa Lower Limit.");
    setErrorMessages(messages);
    return messages.length === 0; 
  };

  const submitData = async () => {
    if (!validateFormForSubmission()) {
      antdMessage.error("Please correct the form errors displayed above."); 
      return;
    }
    setIsSubmitting(true);
    const modelDataForPayload = preparePayload();
    const payload = {
      modelObj: modelDataForPayload,
      userDetail: { userName, userEmail, projectId, projectName }
    };
    console.log("Submitting payload:", payload);
    try {
      const url = "/riva/moleculegenbatches";
      const response = await postRequest(url, payload);
      console.log(response);
      setBatchDetails(response?.data || {}); 
      // antdMessage.success(ATTRIBUTE.SUBMIT_MSG || "Experiment submitted successfully!"); 
      setOpenSubmitConfirmModal(true); 
    } catch (error) {
        antdMessage.error(`Submission failed: ${error.message || "Unknown error"}`);
    } finally {
        setIsSubmitting(false);
    }
  };

  const normalizeForCompare = (value) => {
    if (Array.isArray(value)) return value.map(normalizeForCompare);
    if (value && typeof value === "object") {
      return Object.keys(value).sort().reduce((acc, key) => {
        acc[key] = normalizeForCompare(value[key]);
        return acc;
      }, {});
    }
    return value === undefined ? null : value;
  };

  const hasUnsavedChanges = () => (
    JSON.stringify(normalizeForCompare(formData)) !==
    JSON.stringify(normalizeForCompare(initialFormDataRef.current))
  );

  const discardChangesAndNavigateBack = () => {
    setFormData({...ATTRIBUTE_MODEL}); // Reset form data with a new copy
    navigate(`/${projectId}/result`, { state: { projectName, owners, teamMembers, description } });
  };

  const handleCancel = () => {
    if (!hasUnsavedChanges()) {
      discardChangesAndNavigateBack();
      return;
    }

    AntModal.confirm({
      title: "Unsaved Changes",
      content: "You have unsaved changes. Are you sure you want to discard them?",
      okText: "Discard",
      okButtonProps: { danger: true },
      cancelText: "Keep Editing",
      onOk: discardChangesAndNavigateBack,
    });
  };

  cancelHandlerRef.current = handleCancel;

  useEffect(() => {
    if (typeof onBackHandlerChange !== "function") return undefined;

    onBackHandlerChange(() => cancelHandlerRef.current?.());
    return () => onBackHandlerChange(null);
  }, [onBackHandlerChange]);

  const displayField = (field) => {
    let value = true;
    switch (field) {
        case "ref_compounds": if (formData.include_similarity_to_ref === false) value = false; break;
        case "clogD_limit": case "clogD_l_limit": case "clogD_u_limit": if (formData.include_clogD === false) value = false; break;
        case "pKa_limit": case "pKa_llimit": case "pKa_ulimit": if (formData.include_pKa === false) value = false; break;
        case "potency_model_script": if (formData.include_potency === false) value = false; break;
        case "docking_model": case "docking_model_type": case "docking_reward_utility_function": case "docking_reward_sigmoid_params": if (formData.docking_proxy_filter === false) value = false; break;
        case "medchemrules_thres": if (formData.include_medchemrules === false) value = false; break;
        case "capping_scaffold": if (formData.capping === false) value = false; break;
        case "chiral_centers": case "w_nchiral_0": case "w_nchiral_1": if (formData.limit_chiral_centers === false) value = false; break;
        case "ring_size": case "w_lrsz_0": case "w_lrsz_1": if (formData.limit_ring_size === false) value = false; break;
        case "number_of_rings": case "w_nrings_0": case "w_nrings_1": if (formData.limit_number_of_rings === false) value = false; break;
        case "number_of_aromatic_rings": case "w_arrings_0": case "w_arrings_1": if (formData.limit_number_of_aromatic_rings === false) value = false; break;
        case "rotatable_bonds": case "w_rotbond_0": case "w_rotbond_1": if (formData.limit_rotatable_bonds === false) value = false; break;
        case "halogens": case "w_halogen_0": case "w_halogen_1": if (formData.limit_halogens === false) value = false; break;
        case "OH_NH": case "w_ro5_ohnh_0": case "w_ro5_ohnh_1": if (formData.Limit_OH_NH === false) value = false; break;
        case "polar_surface_area": case "w_nvrtspsa_0": case "w_nvrtspsa_1": if (formData.limit_polar_surface_area === false) value = false; break;
        case "H_bond_donors": case "w_hdons_0": case "w_hdons_1": if (formData.limit_H_bond_donors === false) value = false; break;
        case "H_bond_acceptors": case "w_hacts_0": case "w_hacts_1": if (formData.limit_H_bond_acceptors === false) value = false; break;
        case "SMARTS_file": if (formData.include_tsubmatching === false) value = false; break;
        default: break;
    }
    return value;
  };

  const handleExpandAdvanced = () => { 
    const nextExpandState = !expandAdvancePara;
    setExpandAdvancePara(nextExpandState);
    if (!nextExpandState) { 
      setExpandSubgroup(false); 
    }
  };

  const handleSubgroupCollapseChange = (keyOrKeys) => {
    if (Array.isArray(keyOrKeys)) {
        const newActiveKey = keyOrKeys.length > 0 ? keyOrKeys[0] : false;
        setExpandSubgroup(newActiveKey === expandSubgroup ? false : newActiveKey);
    } else { // Single key string or undefined
        setExpandSubgroup(keyOrKeys === expandSubgroup ? false : keyOrKeys || false);
    }
  };


  return (
    <div style={{ padding: "8px", margin: "auto" }}> 
     {isReTriggerMode && (
              <AntAlert
                message="Caution: Modifying input parameters when restarting an experiment from a previous checkpoint may result in unpredictable or erratic behavior. To ensure consistency and reliability, it's strongly recommended to use the same parameters as those in the original experiment."
                type="warning"
                showIcon
                style={{ marginBottom: 4 }}
              />
          )}
    <Card style={{ marginBottom: 4 }}>
            <Title level={5}>{isReTriggerMode ? "Re-Trigger Experiment" : isCloneMode ? "Clone Experiment" : "Experiment Details"}</Title>
            <Row gutter={16}>
                <Col span={12}>
                    <Text strong>Experiment Name <span style={{color: "red"}}>*</span></Text>
                    <Input 
                        value={formData.exp_name} 
                        onChange={(e) => handleInputChange({target: {name: "exp_name", value: e.target.value}})}
                        placeholder="Enter a name for this experiment"
                        maxLength={50}
                        showCount
                        // ✅ MODIFIED: Disabled only during re-trigger; enabled for clone
                        disabled={isReTriggerMode}
                    />
                </Col>
                <Col span={12}>
                    <Text strong>Description</Text>
                    <Input.TextArea 
                        value={formData.exp_description}
                        onChange={(e) => handleInputChange({target: {name: "exp_description", value: e.target.value}})}
                        placeholder="Optional description"
                        maxLength={250}
                        showCount
                        rows={1}
                        // ✅ MODIFIED: Disabled only during re-trigger; enabled for clone
                        // disabled={isReTriggerMode}
                    />
                </Col>
            </Row>
          </Card>
          
      <ScaffoldCanvas  
        formData={formData}
        setFormData={setFormData}
        disabled={isReTriggerMode}
      />

      <MandatoryParameters  
        formData={formData}
        molecularScaffold={molecularScaffold} 
        learningRelated={learningRelated}
        displayField={displayField}
        handleInputChange={handleInputChange}
        handleSlider={handleSlider}
        handleSigmoidValue={handleSigmoidValue}
        setFormData={setFormData} 
        projectId={projectId}
        isReTriggerMode={isReTriggerMode}
      />

      <AdvancedParameters  
        expandAdvancePara={expandAdvancePara}
        onClickExpand={handleExpandAdvanced} 
        expandSubgroup={expandSubgroup}
        onChangeSubgroup={handleSubgroupCollapseChange} 
        formData={formData}
        molecularScaffoldAdvance={molecularScaffoldAdvance}
        learningRelatedAdvance={learningRelatedAdvance}
        contraintsAdvance={contraintsAdvance}
        displayField={displayField}
        handleInputChange={handleInputChange}
        handleSlider={handleSlider}
        handleSigmoidValue={handleSigmoidValue}
        setFormData={setFormData}
        projectId={projectId}
        isReTriggerMode={isReTriggerMode}
      />
      
      {errorMessages.length > 0 && (
        <AntAlert
          message="Please correct the following errors:"
          description={
            <ul style={{paddingLeft: 20, margin: 0}}>
              {errorMessages.map((msg, index) => (
                <li key={index}>{msg}</li>
              ))}
            </ul>
          }
          type="error"
          closable
          onClose={handleErrorAlertClose}
          style={{ marginBottom: 24, marginTop: 16 }}
          showIcon
        />
      )}

      <Row justify="end" style={{ marginTop: 32, marginBottom: 32 }}> 
        <Space size="middle">
          <Button
            onClick={handleCancel}
            style={{ minWidth: 100 }}
          >
            {BUTTON_LABEL.CANCEL}
          </Button>
          <Button
            type="primary" 
            onClick={submitData} 
            disabled={!isFormValid() || isSubmitting} // Disable if submitting
            loading={isSubmitting} 
            style={{ minWidth: 100 }}
          >
            {BUTTON_LABEL.SUBMIT}
          </Button>
        </Space>
      </Row>
      

<AntModal
  open={openSubmitConfirmModal}
   title="Submission Successful" 
  closable={false}
  footer={null}   /* we’ll render our own single OK button below */
  onCancel={handleCloseSubmitConfirmModal}
>
  {batchDetails && batchDetails.batchId ? (
    <Descriptions
      bordered
      column={1}
      size="small"
      style={{ marginBottom: 16 }}
    >
      <Descriptions.Item label="Message">{batchDetails.message || "Experiment Job Submitted Successfully"}</Descriptions.Item>
      <Descriptions.Item label="Batch&nbsp;Number">
        {batchDetails.batchId}
      </Descriptions.Item>
      <Descriptions.Item label="Timestamp">
        {dayjs(batchDetails.submitted_time).format("YYYY‑MM‑DD HH:mm:ss")}
      </Descriptions.Item>
      <Descriptions.Item label="Submitted&nbsp;By">
        {batchDetails.submitted_id}
      </Descriptions.Item>
    </Descriptions>
  ) : (
    <Spin tip="Processing submission…" />
  )}

  <div style={{ textAlign: "right" }}>
    <Button
      type="primary"
      onClick={() => {
        navigate(`/${projectId}/result`, {
          state: { projectId, projectName, owners, teamMembers, description },
        });
        handleCloseSubmitConfirmModal();
      }}
    >
      {ATTRIBUTE.OPEN_RESULT_PAGE}
    </Button>
  </div>
</AntModal>

    </div>
  );
};

export default Attribute;
